import { Locale } from "@travellocal/utils";

// return de, en, en_GB, (NOTE, NOT "en-gb") based on locale
export const currentMarket = (locale: Locale) => {
  if (locale === "en-gb") {
    return "en_GB";
  }

  return locale;
};
